<template>
    <!-- <el-dialog class="messageBtm" :modal="false" v-draggable width="410px" @close="resetFirst" :visible.sync="showModal"
        :close-on-click-modal="false"> -->
    <div class="hez" v-if="showModal">
        <!-- 消息通知 -->
        <div @click="showModal = false" style="text-align: right;font-size: 20px; margin-right: 10px;"> <i
                class="el-icon-circle-close" slot="reference"></i></div>
        <!-- 头部选项 -->
        <el-menu mode="horizontal" active-text-color="#40aaf7" :default-active="activeIndex" @select="handleSelect"
            class="el-menu-demo">
            <el-menu-item index="1">普通信息({{ MsgArrayTotal.OrdinaryMsgTotal }})</el-menu-item>
            <el-menu-item index="2">强制信息({{ MsgArrayTotal.ForceMsgTotal }})</el-menu-item>
            <el-menu-item index="3">公告消息({{ MsgArrayTotal.NoticeMsgTotal }})</el-menu-item>
        </el-menu>
        <!-- 消息内容 循环部分 -->
        <div class="box" v-if="activeIndex == '1'">
            <div class="notification_text" v-for="(i, index) in MsgArray.OrdinaryMsgArray" :key="index"
                @click="OrdinaryMsg(i)">
                <img src="../../assets/message.png" alt="上升" class="left_image" />
                <div class="text">
                    <p>{{ i.title }}</p>
                    <p style="font-size: 12px; color: #ccc">{{ i.createTime }}</p>
                </div>
            </div>
        </div>
        <div class="box" v-if="activeIndex == '2'">
            <div class="notification_text" v-for="(i, index) in MsgArray.ForceMsgArray" :key="index" @click="ForceMsg(i)">
                <img src="../../assets/message.png" alt="上升" class="left_image" />
                <div class="text">
                    <p>{{ i.title }}</p>
                    <p style="font-size: 12px; color: #ccc">{{ i.createTime }}</p>
                </div>
            </div>
        </div>
        <div class="box" v-if="activeIndex == '3'">
            <div class="notification_text" v-for="(i, index) in MsgArray.NoticeMsgArray" :key="index" @click="NoticeMsg(i)">
                <img src="../../assets/message.png" alt="上升" class="left_image" />
                <div class="text">
                    <p>{{ i.title }}</p>
                    <p style="font-size: 12px; color: #ccc">{{ i.createTime }}</p>
                </div>
            </div>
        </div>

        <OrdinaryMsg ref="OrdinaryMsg"></OrdinaryMsg>
        <ForceMsg ref="ForceMsg"></ForceMsg>
        <NoticeMsg ref="NoticeMsg"></NoticeMsg>
    </div>

    <!-- </el-dialog> -->
</template>
<script>
import OrdinaryMsg from "./OrdinaryMsg.vue";
import ForceMsg from "./ForceMsg.vue";
import NoticeMsg from "./NoticeMsg.vue";
import EventBus from "@/utils/EventBus";
export default {
    name: "dragModal",
    components: {

        OrdinaryMsg,
        ForceMsg,
        NoticeMsg,


    },
    data() {
        return {
            showModal: false, //是否打开弹窗 非0打开
            left: "",
            top: "",
            direction: 'rtl',
            activeIndex: '1',
            connection: null,
            msgs: [],
            dataInfo: { status1: "off", status2: "off" },
            MsgArrayTotal: {
                totalMsg: 0,
                OrdinaryMsgTotal: 0,
                ForceMsgTotal: 0,
                NoticeMsgTotal: 0,
            },
            MsgArray: {
                OrdinaryMsgArray: [],
                ForceMsgArray: [],
                NoticeMsgArray: []

            }
        };
    },
    props: {
        // OrdinaryMsgTotal: {
        //     type: Number,
        //     default: 0
        // },
        // ForceMsgTotal: {
        //     type: Number,
        //     default: 0
        // },
        // NoticeMsgTotal: {
        //     type: Number,
        //     default: 0
        // },
        // MsgArray: {
        //     type: Array,
        //     default: null
        // },


    },

    computed: {},
    created() {
        this.loader()
    },
    mounted() {
        EventBus.$on("MsgshowD", () => {
            this.loader()
            this.showModal = !this.showModal
        });
    },
    beforeDestroy() {
        EventBus.$off("MsgshowD")
    },

    methods: {
        handleSelect(e) {

            this.activeIndex = e
        },

        resetFirst() {
            this.showModal = false
        },
        show(obj) {
            this.msgs = obj
            this.showModal = true
        },
        loader() {

            if (JSON.parse(window.localStorage.getItem('MsgArrayTotal'))) {
                this.MsgArrayTotal = JSON.parse(window.localStorage.getItem('MsgArrayTotal'))
            }
            if (JSON.parse(window.localStorage.getItem('MsgArray'))) {
                this.MsgArray = JSON.parse(window.localStorage.getItem('MsgArray'))
            }


        },
        NoticeMsg(row) {
            this.$notify({
                title: row.title + '     ' + row.createTime,
                dangerouslyUseHTMLString: true,
                message: row.content
            });
        },
        ForceMsg(row) {
            this.$refs.ForceMsg.show(row)
        },
        OrdinaryMsg(row) {
            this.$refs.OrdinaryMsg.show(row)
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="less" scoped>
/deep/ .el-dialog {
    position: absolute;
    /* right: 0; */
    left: 76vw;
    top: 10vh;

}

.hez {
    position: absolute;
    z-index: 99999;
    bottom: 10px;
    right: 10px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 1px 1px 10px 1px #ccc;
}

.el-menu-demo .el-menu-item,
.el-submenu__title {
    height: 35px;
    line-height: 35px;
}

.el-menu-demo {
    padding: 0 20px;
}

//图片
.left_image {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 10px;
    margin-top: -20px;
    border-radius: 50%;
}

//每一条
.notification_text {
    width: 100%;
    height: 80px;
    border-bottom: 1px #ccc solid;
    position: relative;
    cursor: pointer;
}

//底部按钮
.bottom_button {
    width: 330px;
    height: 50px;
    border-top: #ccc 1px solid;
    position: absolute;
    bottom: 0;
    left: 0;
}

//左右按钮
.bottom_button_left,
.bottom_button_right {
    display: inline-block;
    width: 164px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
}

//左按钮
.bottom_button_left {
    border-right: solid 1px #ccc;
}

//左按钮
.bottom_button_left:hover {
    color: #40aaf7;
}

//右按钮
.bottom_button_right:hover {
    color: #40aaf7;
}

//文字部分位置
.text {
    display: inline-block;
    position: absolute;
    top: 5px;
    left: 65px;
}

//内容部分超出隐藏，给滚动条
.box {
    overflow: auto;
    height: 400px;
    /* margin-bottom: 37px; */
}

//滚动条的样式
::-webkit-scrollbar {
    //滚动条宽高
    width: 5px;
    height: 10px;
}

::-webkit-scrollbar-thumb {
    //滚动条颜色和圆角
    background-color: #dbd9d9;
    border-radius: 3px;
}</style>